import * as z from 'zod';

export const environmentSchema = z.enum(['production', 'staging', 'development']);
export type EnvironmentSchema = z.infer<typeof environmentSchema>;

export const environmentMutationSchema = environmentSchema.nullable();
export const environmentQuerySchema = z.enum(['production', 'staging', 'development']).nullable();
export const environmentFormSchema = z.object({
  name: z.string(),
  value: z.enum(['production', 'staging', 'development']),
});

export type EnvironmentQuerySchema = z.infer<typeof environmentQuerySchema>;
export type EnvironmentFormSchema = z.infer<typeof environmentFormSchema>;
export type EnvironmentMutationSchema = z.infer<typeof environmentMutationSchema>;

export const defaultEnvironment: EnvironmentFormSchema = { name: 'Production', value: 'production' };

export function strToEnvironment(environment: EnvironmentQuerySchema): EnvironmentFormSchema {
  return environmentOptions.find((option) => option.value === environment) || defaultEnvironment;
}

export function environmentToStr(environment?: EnvironmentFormSchema): EnvironmentSchema {
  return environment?.value || 'production';
}

export const environmentOptions: EnvironmentFormSchema[] = [
  defaultEnvironment,
  { name: 'Staging', value: 'staging' },
  { name: 'Development', value: 'development' },
];

export const isEnvironmentTrue = (environment: EnvironmentFormSchema | string | null) => {
  if (typeof environment === 'string') {
    return environment !== 'development';
  }

  return environment?.value !== 'development';
};
